import { formatDecimalNumber } from "../../Common/DetailsForm/Presenter/Helpers/formatDecimalNumber";
import type { productReturnRequestItemDisplayVM } from "./productReturnRequestItemDisplayVM";
import "./ProductReturnRequestItemDisplayFragment.scss";
import { Fragment } from "react";

export default function ProductReturnRequestItemDisplayFragment(props: {
  items: productReturnRequestItemDisplayVM[];
}) {
  return (
    <>
      {props.items.length > 0 && (
        <table className="table">
          <thead>
            <tr>
              <th>Poz</th>
              <th>Kod pozycji</th>
              <th>Nazwa towaru</th>
              <th>Numer katalogowy</th>
              <th className="text-center">Ilość do zwrotu</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {props.items.map((item, index) => (
              <Fragment key={item.id}>
                <tr className={rowColorClass(index)}>
                  <td className="text-end">{index + 1}</td>
                  <td>{item.lineCode}</td>
                  <td>{item.productName}</td>
                  <td>{item.catalogNumber}</td>
                  <td className="text-end">
                    {formatDecimalNumber(item.amount, 4)}
                  </td>
                </tr>
                {item.comments && (
                  <tr className={rowColorClass(index)}>
                    <td></td>
                    <td colSpan={4} className="text-break">
                      <b>Uwagi:</b> {item.comments}
                    </td>
                  </tr>
                )}
              </Fragment>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}

function rowColorClass(index: number) {
  return index % 2 === 0 ? "-app-row-odd" : "-app-row-even";
}
